import {Grid2 } from '@mui/material';
import React from 'react';
import TestimonialCard from '../../shared/components/TestimonialCard';
import HorizontalScroll from '../../shared/components/HorizontalScroll'
import { useTestimonial } from '../../assets/api/useGetApi';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';

const TestimonialSection = () => {
    const testimonials = ["#FFEEF2", "#EEF7FF", "#FBFFEE", "#FFF2E7", "#F1EEFF"];
    const { data: testimonial, isLoading } = useTestimonial();
    return (
        <>
            <HorizontalScroll heading={"Read real stories and experiences from our satisfied clients"} subheading={"Hear From Our Happy Customers!"} size={1}>
                {/* {!isLoading && (
                    testimonial?.data?.elements?.map((item, index) => (
                        <Box key={index} sx={{ width: { xs: "600px", lg: "80%" }, flex: "0 0 auto" , display:"flex", alignItems:'stretch' }} >
                            <TestimonialCard item={item} bgColor={testimonials[index % testimonials.length]} />
                        </Box>
                    ))
                )} */}
                {!isLoading && (
                    testimonial?.data?.elements?.map((item, index) => {
                        // Pick a random color from testimonials array
                        const randomBgColor = testimonials[Math.floor(Math.random() * testimonials.length)];
                        return (
                            <Grid2 key={index} size={{xs:12,lg:9}} sx={{flex: "0 0 auto", display: "flex", alignItems: 'stretch' }}>
                                <TestimonialCard item={item} bgColor={randomBgColor} />
                            </Grid2>
                        );
                    })
                )}
                {
                    isLoading && [...Array(6)].map((_, index) => (
                        <Grid2 key={index}  size={{xs:12,lg:9}} sx={{flex: "0 0 auto" }}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                }
            </HorizontalScroll>
        </>
    )
}

export default TestimonialSection